@if (loading()) {
  <!-- Loading -->
  <section class="info-card" aria-busy="true">
    <div class="info-card__skeleton info-card__skeleton--title"></div>
    <div class="info-card__skeleton info-card__skeleton--body"></div>
    <div class="info-card__skeleton info-card__skeleton--body-short"></div>
  </section>
  <!-- ! Loading -->
} @else if (current(); as notice) {
  <!--
    `mouseenter`/`mouseleave` rather than `:hover` because the rotation is state, not
    styling. Only bound when there is something to rotate.
  -->
  <section
    class="info-card"
    role="group"
    aria-label="Avisos"
    (mouseenter)="isCarousel() ? pause() : null"
    (mouseleave)="isCarousel() ? resume() : null"
  >
    <!-- Notice -->
    <h3 class="info-card__title">{{ notice.title }}</h3>

    <p class="info-card__body">
      @for (part of notice.body; track $index) {
        @if (part.emphasis) {
          <em>{{ part.text }}</em>
        } @else {
          <span>{{ part.text }}</span>
        }
      }
    </p>

    @if (notice.cta; as cta) {
      <button class="cds-button s-plain c-secondary info-card__cta" type="button" (click)="cta.action()">
        {{ cta.label }}
        <i class="cds-icon-arrow-right" aria-hidden="true"></i>
      </button>
    }
    <!-- ! Notice -->

    @if (isCarousel()) {
      <!--
        Dots are buttons because they move the carousel. `aria-current` marks the one on
        screen, and the label counts from one so it reads the way the dots look.
      -->
      <nav class="info-card__dots" aria-label="Selecionar aviso">
        @for (dot of notices(); track dot.id; let position = $index) {
          <button
            class="info-card__dot"
            type="button"
            [class.info-card__dot--active]="position === activeIndex()"
            [attr.aria-current]="position === activeIndex() ? 'true' : null"
            [attr.aria-label]="'Aviso ' + (position + 1) + ' de ' + notices().length"
            (click)="select(position)"
          ></button>
        }
      </nav>
    }
  </section>
}
